import { translateText } from "../api/ai";

const hasArabic = (s) => /[\u0600-\u06FF]/.test(s || "");
const hasLatin = (s) => /[A-Za-z]/.test(s || "");

// يضمن أن يكون العنوان كاملاً بلغة الواجهة (عربي↔عربي، إنجليزي↔إنجليزي) بترجمة أي أجزاء بلغة مخالفة عبر Gemini.
export const localizeAddress = async (label, lang) => {
  if (!label) return label;
  if (lang === "en" && hasArabic(label)) return (await translateText(label, "en", "address")) || label;
  if (lang === "ar" && hasLatin(label)) return (await translateText(label, "ar", "address")) || label;
  return label;
};
